// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Data_Unfoldable1 from "../Data.Unfoldable1/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Cart_Cart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic_Cart_ProductItem from "../Restaumatic.Cart.ProductItem/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Menu_Menu from "../Restaumatic.Menu.Menu/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var AllAvailable = /* #__PURE__ */ (function () {
    function AllAvailable() {

    };
    AllAvailable.value = new AllAvailable();
    return AllAvailable;
})();
var NoneAvailable = /* #__PURE__ */ (function () {
    function NoneAvailable() {

    };
    NoneAvailable.value = new NoneAvailable();
    return NoneAvailable;
})();
var SomeAvailable = /* #__PURE__ */ (function () {
    function SomeAvailable() {

    };
    SomeAvailable.value = new SomeAvailable();
    return SomeAvailable;
})();
var getDeliveryTimesStatus = function (allDeliveryTimes) {
    return function (availableDeliveryTimes) {
        var deliveryTimesStatus = (function () {
            if (Data_Array["null"](availableDeliveryTimes)) {
                return NoneAvailable.value;
            };
            if (Data_Array.length(allDeliveryTimes) === Data_Array.length(availableDeliveryTimes)) {
                return AllAvailable.value;
            };
            if (Data_Boolean.otherwise) {
                return SomeAvailable.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Site.Components.Cart.DishesCalculator (line 77, column 3 - line 80, column 32): " + [  ]);
        })();
        return deliveryTimesStatus;
    };
};
var getCurrentAvailabilities = function (cart) {
    return function (menu) {
        var productKeys = Data_Functor.mapFlipped(Data_Functor.functorArray)(Restaumatic_Cart_Cart.productItems(cart))(Restaumatic_Cart_ProductItem.productItemKey);
        var productIds = function (v) {
            if (v instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
                return Restaumatic_UnwrapOperators.mapUnwrapFlipped(Data_Functor.functorArray)()(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductKey(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "parts";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0))(Data_Array_NonEmpty.toArray))(function (v1) {
                    return v1.productId;
                });
            };
            return [  ];
        };
        var comboIds = function (v) {
            if (v instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
                return new Data_Maybe.Just(Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartComboKey(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "comboId";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0));
            };
            return Data_Maybe.Nothing.value;
        };
        var catalogue = Data_Record.getField(Restaumatic_Menu_Menu.hasFieldMenu(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "catalogue";
            }
        })()))(Type_Proxy["Proxy"].value)(menu);
        var availabilitySchedules = Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "availabilitySchedules";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue));
        var allProducts = Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)(Data_Functor.mapFlipped(Data_Functor.functorArray)(productKeys)(productIds)))(Data_Function.flip(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Restaumatic_UnwrapOperators.applyUnwrapFlipped()(catalogue)(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "products";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        }))));
        var allCombos = Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(productKeys)(comboIds)))(Data_Function.flip(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Restaumatic_UnwrapOperators.applyUnwrapFlipped()(catalogue)(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "combos";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        }))));
        var v = Data_Array.catMaybes(Restaumatic_UnwrapOperators.mapUnwrapFlipped(Data_Functor.functorArray)()(allProducts)(function (v1) {
            return v1.availabilitySchedule;
        }));
        var v1 = Data_Array.catMaybes(Restaumatic_UnwrapOperators.mapUnwrapFlipped(Data_Functor.functorArray)()(allCombos)(function (v2) {
            return v2.availabilitySchedule;
        }));
        var availabilityIds = Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)(v1);
        var availabilities = Restaumatic_UnwrapOperators.mapUnwrapFlipped(Data_Functor.functorArray)()(Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(availabilityIds)(Data_Function.flip(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(availabilitySchedules))))(function (v2) {
            return v2.availability;
        });
        return availabilities;
    };
};
var genericDeliveryTimesStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AllAvailable.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return NoneAvailable.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return SomeAvailable.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Site.Components.Cart.DishesCalculator (line 30, column 1 - line 30, column 76): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AllAvailable) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof NoneAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof SomeAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Site.Components.Cart.DishesCalculator (line 30, column 1 - line 30, column 76): " + [ x.constructor.name ]);
    }
};
var generateWholeLocalDayTimes = function (now) {
    return function (tz) {
        var min30 = Data_Maybe.fromMaybe(Data_Bounded.bottom(Data_Time_Component.boundedMinute))(Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute)(30));
        var min0 = Data_Bounded.bottom(Data_Time_Component.boundedMinute);
        var localNow = Data_Time_Local.utcToLocalDateTime(now)(tz);
        var hours = Data_Enum.enumFromTo(Data_Time_Component.enumHour)(Data_Unfoldable1.unfoldable1Array)(Data_Bounded.bottom(Data_Time_Component.boundedHour))(Data_Bounded.top(Data_Time_Component.boundedHour));
        var deliveryTimes = Control_Bind.bind(Control_Bind.bindArray)(hours)(function (hour) {
            return [ new Data_Time.Time(hour, min0, Data_Bounded.bottom(Data_Time_Component.boundedSecond), Data_Bounded.bottom(Data_Time_Component.boundedMillisecond)), new Data_Time.Time(hour, min30, Data_Bounded.bottom(Data_Time_Component.boundedSecond), Data_Bounded.bottom(Data_Time_Component.boundedMillisecond)) ];
        });
        var dateLocal = Data_Time_Local.localDate(localNow);
        var mkTimeChoice = function (time) {
            return new Data_Time_Local.LocalDateTime(dateLocal, time);
        };
        var deliveryTimesLocalToday = Data_Functor.map(Data_Functor.functorArray)(mkTimeChoice)(deliveryTimes);
        return deliveryTimesLocalToday;
    };
};
var eqDeliveryTimesStatus = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDeliveryTimesStatus)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var calculateAvailableFulfillmentTimes = function (defaultTime) {
    return function (cart) {
        return function (menu) {
            return function (deliveryTimes) {
                var toLocalDateTime = Data_Function.flip(Data_Time_Local.utcToLocalDateTime)((Data_Newtype.unwrap()(menu)).timeZone);
                var availabilities = getCurrentAvailabilities(cart)(menu);
                var isAvailableForAllDishes = function (v) {
                    var time = Data_Maybe.maybe(defaultTime)(Data_Newtype.unwrap())(v.value);
                    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (availability) {
                        return Restaumatic_Calendar_Types_Availability.isAvailable(availability)(toLocalDateTime(time));
                    })(availabilities);
                };
                var availableFulfillmentTimes = Data_Array.filter(isAvailableForAllDishes)(deliveryTimes);
                return availableFulfillmentTimes;
            };
        };
    };
};
var calculateDeliveryTimesStatus = function (now) {
    return function (cart) {
        return function (menu) {
            return function (deliveryTimes) {
                var availableDeliveryTimes = calculateAvailableFulfillmentTimes(now)(cart)(menu)(deliveryTimes);
                return getDeliveryTimesStatus(deliveryTimes)(availableDeliveryTimes);
            };
        };
    };
};
var calculateAvailableFulfillmentLocalTimes = function (cart) {
    return function (menu) {
        return function (deliveryLocalTimes) {
            var availabilities = getCurrentAvailabilities(cart)(menu);
            var isAvailableForAllDishes = function (localDateTime) {
                return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (availability) {
                    return Restaumatic_Calendar_Types_Availability.isAvailable(availability)(localDateTime);
                })(availabilities);
            };
            var availableFulfillmentTimes = Data_Array.filter(isAvailableForAllDishes)(deliveryLocalTimes);
            return availableFulfillmentTimes;
        };
    };
};
var calculateAllDayDeliveryTimesStatus = function (now) {
    return function (cart) {
        return function (menu) {
            var deliveryTimesToday = generateWholeLocalDayTimes(now)((Data_Newtype.unwrap()(menu)).timeZone);
            var availableDeliveryTimes = calculateAvailableFulfillmentLocalTimes(cart)(menu)(deliveryTimesToday);
            var deliveryTimesStatus = getDeliveryTimesStatus(deliveryTimesToday)(availableDeliveryTimes);
            return deliveryTimesStatus;
        };
    };
};
export {
    calculateAvailableFulfillmentTimes,
    getDeliveryTimesStatus,
    calculateDeliveryTimesStatus,
    calculateAllDayDeliveryTimesStatus,
    AllAvailable,
    NoneAvailable,
    SomeAvailable,
    genericDeliveryTimesStatus,
    eqDeliveryTimesStatus
};
//# sourceMappingURL=index.js.map
